// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { screen } from "@gcg/XDL/Helpers";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export const textOverflowEllipsis = css`
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const actionOverflowMenu: any = {
    cssOverrides: {
        wrapper: css`
            width: 100%;
            max-width: 30px;
        `,
        menuItem: css`
            color: ${getColor("text.main")};

            &:hover,
            &:focus {
                &,
                * {
                    color: ${getColor("text.main")} !important;
                    background: ${getColor("common.ui3")};
                    text-decoration: none !important;
                }
            }

            @media print {
                display: none;
            }
        `,
    },
    buttonProps: {
        css: css`
            max-width: 100%;

            &:hover,
            &:focus,
            &:active {
                background: ${getColor("common.ui3")};
                border-color: ${getColor("common.ui3")};
            }
        `,
    },
};

export interface PageStructureStyles {
    headerGridItem?: GridItemProps;
    contentOneGridItem?: GridItemProps;
    contentTwoGridItem?: GridItemProps;
    informationGridItem?: GridItemProps;
}

export const pageStructureStyles: PageStructureStyles = {
    headerGridItem: {
        width: 12,
        css: css`
            align-items: flex-end;
        `,
    },
    contentOneGridItem: {
        width: [12, 12, 12, 8, 8],
    },
    contentTwoGridItem: {
        width: [12, 12, 12, 4, 4],
    },
    informationGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
};

export const companyLogoItem: any = {
    css: css`
        display: none;
        padding: 0;

        @media print {
            display: block;
            padding-bottom: 20px;
        }
    `,
};

export const breadcrumbStyles = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        @media print {
            display: none;
        }
    `,
    typographyProps: {
        css: css`
            ${screen("lte", "sm")`
                font-size: 12px;
                line-height: 18px;
            `}
        `,
    },
};

export const zoneTitle: TypographyPresentationProps = {
    weight: "normal",
    size: 16,
    color: "primary.contrast",
    css: css`
        padding: 2px 5px;
        background-color: ${getColor("text.main")};
        display: block;
        margin: 10px 5px -8px 5px;
    `,
};

export const pageVisibleOverflow = css`
    ${({ theme }) =>
        breakpointMediaQueries(
            theme,
            [
                css`
                    overflow: visible; /* needed for Safari */
                    position: relative; /* needed for Safari */
                `,
                css`
                    overflow: visible; /* needed for Safari */
                    position: relative; /* needed for Safari */
                `,
            ],
            "max",
        )}
`;

export const spinnerStyle: any = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        color: "primary.main",
        css: css`
            margin: auto;
        `,
    },
};

export const loadingOverflow: any = {
    css: css`
        width: 100%;
    `,
    spinnerProps: {
        color: "primary.main",
    },
};

export const filterHeading: any = {
    variant: "h5",
    as: "h2",
    css: css`
        margin: 0 5px 0 0;
        ${screen("lte", "sm")`
            display: none;
        `}
    `,
};
